<template>
  <section>
    <SectionTitle>
      <span class="text-theme">1.</span> {{ $t('banksPage.stepName') }}
      <a v-if="countries.length > 1" href="#" v-on:click.prevent="isShowModal = true" class="dashed-link">{{countryName}}</a>
      <span v-else>{{countryName}}</span>
    </SectionTitle>
    <Modal
      :isShow="isShowModal"
      :isShowFooter="false"
      size="sm"
      v-on:close="isShowModal = false"
    >
      <div class="p-3">
        <a :href="`?country=${country}`"
          v-for="(country, index) in countries"
          :key="`country-${countriesNames[country]}`"
          v-on:click.prevent="setSelectedCountry(country)"
          class="bg-hover text-decoration-none text-dark d-flex align-items-center"
          :class="{'bg-hover--active': country === selectedCountry, 'mb-1': index + 1 < countries.length}"
        >
          <img :src="require(`../../assets/flags/${country}.svg`)" class="flag-icon mr-3" alt="lang">
          <span class="d-block">{{countriesNames[country]}}</span>
        </a>
      </div>
    </Modal>
  </section>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import SectionTitle from '../elements/SectionTitle'
import { countriesNames } from '../../constants'
import { SET_PERSONAL_STATE_VALUE } from '../../store/modules/personal/variables'

export default {
  data() {
    return {
      isShowModal: false,
      countriesNames
    }
  },
  components: {
    SectionTitle
  },
  computed: {
    ...mapGetters('personal', ['selectedCountry']),
    ...mapState('base', ['countries']),
    countryName() {
      return this.countriesNames[this.selectedCountry]
    }
  },
  beforeMount() {
    this.countriesRequest()
  },
  methods: {
    ...mapMutations('personal', [SET_PERSONAL_STATE_VALUE]),
    ...mapActions('base', ['countriesRequest']),
    setSelectedCountry(country) {
      this[SET_PERSONAL_STATE_VALUE](['selectedCountry', country])
      this.isShowModal = false
    }
  }
}
</script>
